export default __webpack_public_path__ + "static/spacescenecaplowopacity-a038c8448846c550dc8d2ec159e28a57.png";